"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchJSON;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _nodeFetch = _interopRequireDefault(require("node-fetch"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Helper function for fetching network resource as JSON
function fetchJSON(_x, _x2) {
  return _fetchJSON.apply(this, arguments);
}

function _fetchJSON() {
  _fetchJSON = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url, options) {
    var res;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _nodeFetch.default)(url, _objectSpread(_objectSpread({}, options), {}, {
              headers: _objectSpread(_objectSpread({}, options.headers), {}, {
                accept: 'application/json'
              })
            }));

          case 2:
            res = _context.sent;

            if (res.ok) {
              _context.next = 5;
              break;
            }

            throw new Error("Failed to fetch JSON from server due to ".concat(res.status));

          case 5:
            return _context.abrupt("return", res.json());

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchJSON.apply(this, arguments);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9mZXRjaEpTT04uanMiXSwibmFtZXMiOlsiZmV0Y2hKU09OIiwidXJsIiwib3B0aW9ucyIsImhlYWRlcnMiLCJhY2NlcHQiLCJyZXMiLCJvayIsIkVycm9yIiwic3RhdHVzIiwianNvbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7OztBQUVBO1NBQzhCQSxTOzs7Ozt1RkFBZixpQkFBeUJDLEdBQXpCLEVBQThCQyxPQUE5QjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLG1CQUNLLHdCQUFNRCxHQUFOLGtDQUNiQyxPQURhO0FBRWhCQyxjQUFBQSxPQUFPLGtDQUNGRCxPQUFPLENBQUNDLE9BRE47QUFFTEMsZ0JBQUFBLE1BQU0sRUFBRTtBQUZIO0FBRlMsZUFETDs7QUFBQTtBQUNQQyxZQUFBQSxHQURPOztBQUFBLGdCQVNSQSxHQUFHLENBQUNDLEVBVEk7QUFBQTtBQUFBO0FBQUE7O0FBQUEsa0JBVUwsSUFBSUMsS0FBSixtREFBcURGLEdBQUcsQ0FBQ0csTUFBekQsRUFWSzs7QUFBQTtBQUFBLDZDQWFOSCxHQUFHLENBQUNJLElBQUosRUFiTTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxHIiwic291cmNlUm9vdCI6ImRpcmVjdGxpbmVzcGVlY2g6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGZldGNoIGZyb20gJ25vZGUtZmV0Y2gnO1xuXG4vLyBIZWxwZXIgZnVuY3Rpb24gZm9yIGZldGNoaW5nIG5ldHdvcmsgcmVzb3VyY2UgYXMgSlNPTlxuZXhwb3J0IGRlZmF1bHQgYXN5bmMgZnVuY3Rpb24gZmV0Y2hKU09OKHVybCwgb3B0aW9ucykge1xuICBjb25zdCByZXMgPSBhd2FpdCBmZXRjaCh1cmwsIHtcbiAgICAuLi5vcHRpb25zLFxuICAgIGhlYWRlcnM6IHtcbiAgICAgIC4uLm9wdGlvbnMuaGVhZGVycyxcbiAgICAgIGFjY2VwdDogJ2FwcGxpY2F0aW9uL2pzb24nXG4gICAgfVxuICB9KTtcblxuICBpZiAoIXJlcy5vaykge1xuICAgIHRocm93IG5ldyBFcnJvcihgRmFpbGVkIHRvIGZldGNoIEpTT04gZnJvbSBzZXJ2ZXIgZHVlIHRvICR7cmVzLnN0YXR1c31gKTtcbiAgfVxuXG4gIHJldHVybiByZXMuanNvbigpO1xufVxuIl19